import { axios } from "../../../shared/lib/axios";
import { useMutation } from "@tanstack/react-query";

async function signUpRequest(data) {
  const { config, ...rest } = data;
  const temp = {
    ...rest,
    documentNumber: data.documentNumber
      ?.replaceAll(".", "")
      .replaceAll("-", ""),
  };
  const res = await axios.apiCadernoVirtual.post(
    "/autenticacao-service/newUser",
    temp,
    { ...(config || {}) }
  );
  return res;
}

export const useSignUpUser = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: signUpRequest });
};
